export default __webpack_public_path__ + "static/media/logo-white-baseline.faf814ab.png";